module.exports = "https://trybtryb-legacy.web.app/img/bath-bomb.010f071c.webp";